const EmbedSupportScript = () => {
  // This script listens for messages from the embedded iframe to resize itself
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
  function beehiiv_resizeIframe(id, height, _reason) {
    if (!id || !height) return;
    const iframe = document.getElementById(id);
    if (!iframe) return;
    iframe.style.height = height + 'px';
  }

  function beehiiv_messageHandler(event) {
    if (event.data && event.data.type === 'beehiiv:iframe_height') {
      beehiiv_resizeIframe(event.data.id, event.data.height, event.data.reason);
    }
  }

  window.addEventListener('message', beehiiv_messageHandler);
  `,
      }}
    />
  );
};

export default EmbedSupportScript;
